import { v4 as uuid } from "uuid";

export function pushAnalyticsEvent({
  eventName,
  ...rest
}: { eventName: string } & Record<string, unknown>): void {
  pushEventToDataLayer({
    event: eventName,
    ...rest,
  });
  pushToAmplitude(eventName, rest);
}

export function pushEventToDataLayer(
  item: { event: string } & Record<string, unknown>
): void {
  pushVariablesToDataLayer(item);
}

export function pushVariablesToDataLayer(item: Record<string, unknown>) {
  if (
    typeof window?.dataLayer?.push === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    window.dataLayer.push(item);
  }
}

export function pushToAmplitude(
  eventName: string,
  eventProperties: Record<string, unknown>
): void {
  if (
    typeof window?.amplitude?.getInstance === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    window.amplitude.getInstance().logEvent(eventName, eventProperties);
  }
}

export function identifyUser(userId: string): void {
  if (
    typeof window?.amplitude?.getInstance === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    window.amplitude.getInstance().setUserId(userId);
  }
}

export function pushExperimentToAmplitude(name: string, variant: string): void {
  if (
    typeof window?.amplitude?.getInstance === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    const instance = window.amplitude.getInstance();
    instance.setUserProperties({ [name]: variant });
    instance.logEvent(`Experiment Viewed`, { name, variant });
  }
}

export function uniqueIdentifier(): string {
  return uuid();
}
